// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyDIrlgCyN2GvYdpOSRBsxNm9Q3sID-YoFs",
    authDomain: "insayr-fd71a.firebaseapp.com",
    projectId: "insayr-fd71a",
    storageBucket: "insayr-fd71a.firebasestorage.app",
    messagingSenderId: "131477192904",
    appId: "1:131477192904:web:a0333d728f4e3d1f5c25fd",
    measurementId: "G-T5CTY2D6S6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firebase Cloud Messaging and export it
const messaging = getMessaging(app);

// In your main entry file, such as index.js
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`)
    .then((registration) => {
    })
    .catch((error) => {
    });
}

export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  let token = "";
  if (permission === "granted") {
    try {
      const serviceWorkerRegistration = await navigator.serviceWorker.ready;
      token = await getToken(messaging, {
        vapidKey: 'BHWRvoaRc6CQX7cTqGGAmEoqSBi8cefMSaNUZaCSWgOrao6YTcQMr2tzysMicds4dPzaSJP9Zzn4Hu1X02jMJyM',
        serviceWorkerRegistration,
      });
    } catch (error) {
    }
  } else {
  }
  return token;
};


export { messaging };
